import { Button } from '#/components/Button/Button';
import { FlagListingContainer } from '#/containers/FlagListingContainer';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { ListingType } from '#/types/ListingType';

type Props = {
  listingId: string;
  listingType: ListingType;
};

export function ReportListingMenuItem({ listingId, listingType }: Props) {
  const { i18n } = useI18n();

  return (
    <FlagListingContainer
      listingId={listingId}
      listingType={listingType}
      render={({ flagListing }) => (
        <Button
          type="button"
          qaId="flag-content"
          onClick={() => {
            flagListing();
          }}
          variant="tertiary-grey"
          icon={{ name: 'flag' }}
          size="small"
        >
          {i18n('Report This Listing')}
        </Button>
      )}
    />
  );
}
